import { Link } from 'react-router-dom'
import type { NavChild, NavItem } from '@/data/site'
import { navigation } from '@/data/site'

/**
 * The site's primary navigation, rendered inside the template's `#mobile-menu`
 * container so meanmenu can clone it into the offcanvas drawer. It is driven by
 * the single `navigation` source of truth in `@/data/site`.
 *
 * `Home` and `Services` are plain links: Home has no mega-menu and each service
 * has its own `/services/:slug` detail page rather than a Services submenu.
 */

function ChildItem({ item }: { item: NavChild }) {
  if (item.children?.length) {
    return (
      <li className="has-dropdown">
        <a href={item.to}>
          {item.label} <i className="fa-solid fa-chevron-right"></i>
        </a>
        <ul className="submenu">
          {item.children.map((child) => (
            <ChildItem key={child.label} item={child} />
          ))}
        </ul>
      </li>
    )
  }

  return (
    <li>
      <Link to={item.to}>{item.label}</Link>
    </li>
  )
}

function TopItem({ item }: { item: NavItem }) {
  if (!item.children?.length) {
    return (
      <li>
        <Link to={item.to ?? '#'}>{item.label}</Link>
      </li>
    )
  }

  return (
    <li>
      <a href={item.to ?? '#'}>
        {item.label}
        <i className="fa-solid fa-angle-down"></i>
      </a>
      <ul className="submenu">
        {item.children.map((child) => (
          <ChildItem key={child.label} item={child} />
        ))}
      </ul>
    </li>
  )
}

export function MainMenu() {
  return (
    <div className="main-menu">
      <nav id="mobile-menu">
        <ul>
          {navigation.map((item) => (
            <TopItem key={item.label} item={item} />
          ))}
        </ul>
      </nav>
    </div>
  )
}
